import React, { useState, useEffect, useContext } from "react";
import bannerImg from "./styles/img/banner.jpg";
import logoImg from "./styles/img/logo.svg";
import styles from "./styles/WelcomePopup.module.css";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { Button } from "antd";
import useWindowDimensions from "../../Footer/footer";
import { useNavigate } from "react-router-dom";
export function WelcomePopup({ onClose, code = undefined }) {
  const websiteCurrentLang = useContext(LanguageContext).language;
  const { width } = useWindowDimensions();
  const navigate = useNavigate();
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const closePopup = () => {
    onClose();
  };

  return (
    <>
      <div className={styles.popup_container}>
        <div className={styles.popup}>
          <div className={styles.header}>
            <div className={styles.title}>
              <div>{dublicatedcontent?.welcome_to}</div>
              <div className={styles.logo_row}>
                <img className={styles.logo} src={logoImg} alt="Ostreon" />
                <span>Inheritance!</span>
              </div>
            </div>
            <div className={styles.subtitle}>
              {dublicatedcontent?.dublicatedText236}
            </div>
            <button className={styles.close_btn} onClick={closePopup}></button>
          </div>
          <img
            className={styles.img}
            src={bannerImg}
            alt={`${dublicatedcontent?.welcome_to} Ostreon`}
          />
          <div className={styles.footer}>
            {!code && (
              <div className={styles.bottom_title}>
                {dublicatedcontent?.start_1_month_trial}
              </div>
            )}
            <div
              className={styles.buttonContainer}
              style={{ justifyContent: "center" }}
            >
              <Button
                style={{
                  backgroundColor: "rgba(0, 145, 234, 1)",
                  width: "max-content",
                }}
                onClick={(e) => {
                  navigate("/user/plan");
                  closePopup();
                }}
                className={styles.button}
              >
                {dublicatedcontent.dublicatedText240}
              </Button>
              <Button
                onClick={(e) => {
                  closePopup();
                }}
                style={
                  websiteCurrentLang?.label === "fr" && width > 670
                    ? {
                        position: "relative",
                        right: "0",
                      }
                    : websiteCurrentLang?.label === "en"
                    ? { right: "30px" }
                    : {}
                }
                className={`${styles.button} ${styles.button_absolute}`}
              >
                {dublicatedcontent.dublicatedText242}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WelcomePopup;
